"use strict";import{tag as a}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Checkmark100Icon=({width:t=24,height:e=24,title:r="Checkmark100"}={})=>a`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    aria-hidden="true"
    role="img"
    fill="currentColor"
    aria-label=${r}
    width=${t}
    height=${e}
  >
    <path
      d="M3.5 9.5a.999.999 0 01-.774-.368l-2.45-3a1 1 0 111.548-1.264l1.657 2.028 4.68-6.01A1 1 0 019.74 2.114l-5.45 7a1 1 0 01-.777.386z"
    />
  </svg>`;
//# sourceMappingURL=Checkmark100.js.map
